import { createSlice } from '@reduxjs/toolkit'
import {
  fetchBlackjackGameReport,
  fetchChopperCrashGameReport,
  fetchCoinFlipGameReport,
  fetchCrashGameReport,
  fetchDiceGameReport,
  fetchGongaMineGameReport,
  fetchHiloGameReport,
  fetchKenoGameReport,
  fetchLimboGameReport,
  fetchMinesGameReport,
  fetchMultiCrashGameReport,
  fetchPlinkoGameReport,
  fetchPyramidPlinkoGameReport,
  fetchRouletteGameReport,
  fetchSoccerCrashGameReport,
  fetchSpaceDiceGameReport,
  fetchVideoPokerGameReport,
  fetchTowerGameReport,
  fetchCrossGameReport
} from 'redux-thunk/thunk/GameReports/gameReports'

const initialState = {
  crashGameReport: null,
  diceGameReport: null,
  plinkoGameReport: null,
  kenoGameReport: null,
  videoPokerReport: null,
  hiloGameReport: null,
  blackjackGameReport: null,
  limboGameReport: null,
  minesGameReport: null,
  rouletteGameReport: null,
  coinFlipGameReport: null,
  multiCrashGameReport: null,
  chopperCrashGameReport: null,
  soccerCrashGameReport: null,
  pyramidPlinkoGameReport: null,
  gongaMineGameReport: null,
  spaceDiceGameReport: null,
  towerGameReport:  null,
  crossGameReport: null
}

const gameReportsSlice = createSlice({
  name: 'gameReportsSlice',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchCrashGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          crashGameReport: action.payload
        }
      })
      .addCase(fetchDiceGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          diceGameReport: action.payload
        }
      })
      .addCase(fetchPlinkoGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          plinkoGameReport: action.payload
        }
      })
      .addCase(fetchKenoGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          kenoGameReport: action.payload
        }
      })
      .addCase(fetchVideoPokerGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          videoPokerReport: action.payload
        }
      })
      .addCase(fetchHiloGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          hiloGameReport: action.payload
        }
      })
      .addCase(fetchBlackjackGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          blackjackGameReport: action.payload
        }
      })
      .addCase(fetchLimboGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          limboGameReport: action.payload
        }
      })
      .addCase(fetchMinesGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          minesGameReport: action.payload
        }
      })
      .addCase(fetchRouletteGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          rouletteGameReport: action.payload
        }
      })
      .addCase(fetchCoinFlipGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          coinFlipGameReport: action.payload
        }
      })
      .addCase(fetchMultiCrashGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          multiCrashGameReport: action.payload
        }
      })
      .addCase(fetchChopperCrashGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          chopperCrashGameReport: action.payload
        }
      })
      .addCase(fetchSoccerCrashGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          soccerCrashGameReport: action.payload
        }
      })
      .addCase(fetchPyramidPlinkoGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          pyramidPlinkoGameReport: action.payload
        }
      })
      .addCase(fetchGongaMineGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          gongaMineGameReport: action.payload
        }
      })
      .addCase(fetchSpaceDiceGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          spaceDiceGameReport: action.payload
        }
      })
      .addCase(fetchTowerGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          towerGameReport: action.payload
        }
      })
      .addCase(fetchCrossGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          crossGameReport: action.payload
        }
      })
  }
})

export default gameReportsSlice.reducer
